import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative z-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiInput, {
      name: _ctx.inputName,
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (
				_ctx.$emit('update:modelValue', $event)
			)),
      label: _ctx.label,
      type: "phone",
      autocomplete: "off",
      disabled: _ctx.loading,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focused = true)),
      onBlur: _ctx.onBlur
    }, null, 8, ["name", "modelValue", "label", "disabled", "onBlur"])
  ]))
}